<template>
  <b-card-actions action-collapse title="Price">
    <b-form>
      <b-row>
        <b-col md="6">
          <b-form-group>
            <label>Selling Price</label>

            <b-input-group prepend="฿">
              <b-form-input
                :value="formatNumber(input.salePrice)"
                @input="handleSaleInput"
                type="text"
                placeholder="Selling Price"
              />
            </b-input-group>
            <small class="text-muted">{{ formatNumber(input.salePriceSqm) }} ฿ / sqm</small>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group class="mb-0" :class="{ 'is-invalid': rentPriceError }">
            <label>Rent Price</label>

            <b-input-group prepend="฿">
              <b-form-input
                :value="formatNumber(input.rentPrice)"
                @input="handleRentInput"
                type="text"
                placeholder="Rent Price"
                :state="rentPriceError ? false : null"
              />
            </b-input-group>
            <small class="text-muted">{{ formatNumber(input.rentPriceSqm) }} ฿ / sqm</small>
            <small v-if="rentPriceError" class="text-danger d-block">
              {{ rentPriceErrorMessage }}
            </small>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </b-card-actions>
</template>

<script>
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BInputGroup
} from 'bootstrap-vue'
import BCardActions from '../../../@core/components/b-card-actions/BCardActions.vue'
import axios from '@axios'
import router from '@/router'

export default {
  components: {
    BCardActions,
    BForm,
    BFormGroup,
    BRow,
    BCol,
    BFormInput,
    BInputGroup
  },

  data() {
    return {
      id: router.currentRoute.params.id,
      input: {
        salePrice: null,
        salePriceSqm: null,
        rentPrice: null,
        rentPriceSqm: null
      },
      sqm: 0,
      rentPriceError: false,
      rentPriceErrorMessage: ''
    }
  },

  created() {
    if (this.id) {
      this.fetchPriceData()
    }
  },

  methods: {
    async fetchPriceData() {
      try {
        const { data } = await axios.get(`property/v1/getdetail/${this.id}`)
        const prices = data?.data?.[0]

        if (!prices) return

        this.input.salePrice = prices.sale_price
        this.input.rentPrice = prices.rent_price
        this.sqm = prices.sqm

        this.calculatePricePerSqm()
        this.validateRentPrice()
        this.emitToParent()

      } catch (err) {
        console.error('Error fetching price data:', err)
      }
    },

    calculatePricePerSqm() {
      if (!this.sqm || this.sqm <= 0) return

      this.input.salePriceSqm = this.input.salePrice
        ? Math.round(this.input.salePrice / this.sqm)
        : null

      this.input.rentPriceSqm = this.input.rentPrice
        ? Math.round(this.input.rentPrice / this.sqm)
        : null
    },

    validateRentPrice() {
      this.rentPriceError = false
      this.rentPriceErrorMessage = ''

      const rent = Number(this.input.rentPrice)
      const sale = Number(this.input.salePrice)

      if (!rent) return

      if (rent > 1500000) {
        this.rentPriceError = true
        this.rentPriceErrorMessage = 'Rent price cannot be more than 1,500,000'
        return
      }

      if (sale && rent > sale) {
        this.rentPriceError = true
        this.rentPriceErrorMessage = 'Rent price cannot be more than sale price'
        return
      }
    },

    handleSaleInput(value) {
      const number = this.parseNumber(value)
      this.input.salePrice = number

      this.calculatePricePerSqm()
      this.validateRentPrice()
      this.emitToParent()
    },

    handleRentInput(value) {
      const number = this.parseNumber(value)
      this.input.rentPrice = number

      this.calculatePricePerSqm()
      this.validateRentPrice()

      if (!this.rentPriceError) {
        this.emitToParent()
      }
    },

    parseNumber(value) {
      if (!value) return null
      return Number(String(value).replace(/,/g, '').replace(/[^0-9.]/g, ''))
    },

    formatNumber(value) {
      if (value === null || value === undefined) return ''
      return Number(value).toLocaleString()
    },

    emitToParent() {
      this.$emit('childToParent', { ...this.input })
    },

    validateForm() {
      this.validateRentPrice()
      return !this.rentPriceError
    }
  }
}
</script>

<style scoped>
.form-group.is-invalid {
  border-left: 3px solid #ea5455;
  background-color: rgba(234, 84, 85, 0.06);
  border-radius: 0.357rem;
  padding: 0.75rem 0.75rem 0.5rem;
}
</style>